import axios from 'axios';
import { displayNotificationMessage } from './index'
import { toDateString } from '../views/dashboard/util'
import { getCheckIns } from './weighins'
import { load as loadBadges} from "./badge";
import config from '../config'
const API_ROOT = config.API_ROOT
export function loadProfile(id) {
  return (dispatch) => {
    dispatch({ type: 'FETCH_USER', jwt_user_id: id })
    return new Promise((resolve, reject) => {
      axios.get(API_ROOT + '/profile/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'FETCH_USER_FULFILLED', payload: res.data });
          dispatch(getCheckIns(id));
          dispatch(loadBadges());
          resolve(res);
        }).catch((err) => {
          dispatch({ type: 'REQUIRE_LOGIN', payload: { error: (err.response) ? err.response.data : '' }})
          reject(err);
      });
    });
  }
}

export function login(email, password) {
  return {
    type: 'LOGIN',
    payload: axios.post(API_ROOT + '/login', { username: email, password: password })
  }
}

export function requireLogin(message) {
  return {
    type: 'REQUIRE_LOGIN',
    payload: {
      error: message
    }
  }
}

export function updateTaskList(id, key) {
  return (dispatch) => {
    axios.put(API_ROOT + '/tasks/' + id + '/' + key, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
  }
}

export function requestDeleteAccount(email) {
  return {
    type: 'REQUEST_DELETE_ACCOUNT',
    payload: axios.post(API_ROOT + '/request-delete-account', { email: email })
  }
}

export function confirmDeleteAccount(email, code) {
  return {
    type: 'CONFIRM_DELETE_ACCOUNT',
    payload: axios.post(API_ROOT + '/confirm-delete-account', { email: email, code: code })
  }
}

export function resetPassword(email) {
  return {
    type: 'RESET_PASSWORD',
    payload: axios.post(API_ROOT + '/reset', { email: email })
  }
}

export function resetNewPassword(key, password) {
  return {
    type: 'RESET_NEW_PASSWORD',
    payload: axios.post(API_ROOT + '/reset-password', {
      token: key,
      password: password,
    })
  }
}

export function requireEmail(message) {
  return {
    type: 'REQUIRE_EMAIL',
    payload: {
      error: message
    }
  }
}

export function modifyUser(id, mods, skipMessage) {
  return (dispatch) => {
    mods['local_today'] = toDateString(new Date());
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/users/' + id, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          // console.log(res.data.coaching)
          // console.log(res.data.coaching.description)
          if(res.data.coaching && !skipMessage)
            dispatch(displayNotificationMessage(res.data.coaching))
          // else if (res.data.message)
          //   dispatch(displayNotificationMessage('Coaching Mode', res.data.coaching.message))
          dispatch({ type: 'MODIFY_USER_FULFILLED', payload: res.data });
          dispatch(loadProfile(id));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'MODIFY_USER_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
}

export function modifyPortalUser(id, mods) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/portal-account/' + id, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          if(res.data.coaching)
            dispatch(displayNotificationMessage(res.data.coaching))
          dispatch({ type: 'MODIFY_PORTAL_USER_FULFILLED', payload: res.data });
          dispatch(loadProfile(id));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'MODIFY_PORTAL_USER_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
}

export function cancelSubscription(id, cancelReasons) {
  return {
    type: 'CANCEL_SUBSCRIPTION',
    payload: axios.put(API_ROOT + '/cancel/' + id, cancelReasons, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
  }
}

export function updateSubscription(id, nonce, newCycle) {
  return {
    type: 'UPDATE_SUBSCRIPTION',
    payload: axios.put(API_ROOT + '/update-billing/' + id, {
      nonce: nonce,
      selected_cycle: newCycle
    }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
  }
}

export function softDeclineRetry(id) {
  return {
    type: 'DECLINE_RETRY',
    payload: axios.post(API_ROOT + '/soft-decline-retry/' + id, {
    }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
  }
}

export function saveHighLow(userId, highLowFactor, highLowMask, highLowTweaks, reportDate) {
  return {
    type: 'SAVE_HIGHLOW',
    payload: axios.post(API_ROOT + '/highlow', {
      user_id: userId,
      high_low_factor: highLowFactor,
      high_low_mask: highLowMask,
      high_low_tweaks: highLowTweaks,
      report_date: reportDate
    }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
  }
}

export function createTicket(name, email, subject, message) {
  return {
    type: 'CREATE_TICKET',
    payload: axios.post(API_ROOT + '/contact', {
      name: name,
      email: email,
      subject: subject,
      message: message
    })
  }
}

export function setProfilePicture(pic, id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/upload/', {file_name: pic.newName, user_id: id}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
        axios.put(res.data, pic).catch((err) => { reject(err) });
      }).then((res) => {
        dispatch({type: 'SUBMIT_PROFILE_PIC_FULFILLED', payload: 'Successfully uploaded'})
        resolve(res)
      }).catch((err) => {
        reject(err)
      });
    });
  }
}

export function editUserField(mods) {
  return {
    type: 'EDIT_USER_FIELD',
    payload: mods
  }
}

export function loadUserMacros(userId) {
  return (dispatch) => {
    dispatch({ type: 'FETCH_MACROS' })
    return new Promise((resolve, reject) => {
      axios.get(API_ROOT + '/macros/' + userId, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
        dispatch({ type: 'FETCH_MACROS_FULFILLED', payload: res.data });
        resolve(res);
      }).catch((err) => {
        dispatch({ type: 'FETCH_MACROS_FAILED', payload: { error: 'Error getting macros: ' + err }})
        reject(err);
      });
    });
  }
}

export function getWeighInDetails(user_id, dateString) {
  return dispatch => {
    dispatch({ type: 'FETCH_WEIGH_IN_DETAILS', dateString: dateString })
    return new Promise((resolve, reject) => {
      axios
      .get(API_ROOT + '/weigh-in-details/' + user_id + '/' + dateString, {
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }
      })
      .then(res => {
        dispatch({ type: 'FETCH_WEIGH_IN_DETAILS_FULFILLED', payload: res.data });
      })
      .catch((err) => {
        console.log(err)
        throw Error('Failed to retrieve weigh-in details');
      });
    });
  };
}

export function getBillingInfo(user_id) {
  return dispatch => {
    dispatch({ type: 'FETCH_BILLING' })
    return new Promise((resolve, reject) => {
      axios
      .get(API_ROOT + '/billing-info/' + user_id, {
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }
      })
      .then(res => {
        dispatch({ type: 'FETCH_BILLING_FULFILLED', payload: res.data });
      })
      .catch((err) => {
        console.log(err)
        throw Error('Failed to retrieve billing info');
      });
    });
  };
}

export function updateMacroAdjustment(userId, dateString, data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/macro-adjustment/' + userId + '/' + dateString, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export function updateAuxiliary(userId, data) {
  data['local_today'] = toDateString(new Date());
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/auxiliary/' + userId, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export function insertDailyWeight(userId, date, data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(API_ROOT + '/daily-weight/' + userId + '/' + date, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        dispatch({ type: 'ADD_USER_DAILY_WEIGHTS', payload: {date: date, weight: data.weight} });
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export function updateDailyWeight(userId, date, data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/daily-weight/' + userId + '/' + date, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        dispatch({ type: 'MODIFY_USER_DAILY_WEIGHTS', payload: {date: date, weight: data.weight} });
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export function alertMessagesShown(ids) {
  return {
    type: 'ALERT_MESSAGES_SHOWN',
    payload: ids
  }
}

export function reportAlertMessagesShown(userId, ids) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(API_ROOT + '/alert-messages-shown/' + userId, { ids: ids }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export function completeOnboardingLesson(userId, lessonId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/onboarding/' + userId + '/' + lessonId, { user_id: userId, lesson_id: lessonId }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        dispatch({ type: 'COMPLETE_ONBOARDING_LESSON', payload: lessonId });
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export function logCoachingMessageAction(userId, id, action) {
  return {
    type: 'LOG_COACHING_MESSAGE_ACTION',
    payload: axios.post(API_ROOT + '/coaching-message-action', {
      user_id: userId,
      id: id,
      action: action
    }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
  }
}
export function loadMeasurements(userId, reportDate) {
  return dispatch => {
    dispatch({ type: 'FETCH_MEASUREMENTS' })
    return new Promise((resolve, reject) => {
      axios
      .get(API_ROOT + `/measurements/${userId}/${reportDate}`, {
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }
      })
      .then(res => {
        dispatch({ type: 'FETCH_MEASUREMENTS_FULFILLED', 
        payload: {
          id: res.data.result.id,
          user_weight_id: res.data.result.user_weight_id,
          report_date: reportDate,
          data: res.data.result.data
        }
        });
      })
      .catch((err) => {
        if (err?.response?.data?.error_code === 'measurements-not-found') {
          return Promise.resolve({
            data: {
              result: {
                data: {},
              },
            },
          });
        }
        console.log(err)
      });
    });
  };
}

export function addNote(userId, request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(API_ROOT + '/notes', request, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'ADD_NOTE_FULFILLED', payload: res.data });
          dispatch(loadProfile(userId));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'ADD_NOTE_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
};

export function editNote(userId, request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/notes', request, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'EDIT_NOTE_FULFILLED', payload: res.data });
          dispatch(loadProfile(userId));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'EDIT_NOTE_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
};

export function deleteNote(userId, noteId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(API_ROOT + `/notes/${userId}/${noteId}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'DELETE_NOTE_FULFILLED', payload: res.data });
          dispatch(loadProfile(userId));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'DELETE_NOTE_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
};

export function deleteDailyWeight(userId, date) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(API_ROOT + `/daily-weight/${userId}/${date}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'DELETE_DAILY_WEIGHT_FULFILLED', payload: res.data });
          dispatch(loadProfile(userId));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'DELETE_DAILY_WEIGHT_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
};

export function saveMeasurements(userId, measurementId, data, weighinReportDate) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + `/measurements/${userId}/${measurementId}`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'SAVE_MEASUREMENT_FULFILLED', payload: {data: data.data, weighinReportDate: weighinReportDate} });
          dispatch(loadProfile(userId));
          resolve(res);
        }).catch((err) => {
          dispatch({type: 'SAVE_MEASUREMENT_REJECTED', payload: {error: err}})
          reject(err);
      });
    });
  }
};

export function addMeasurements(userId, data, weighinReportDate) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(API_ROOT + `/measurements/${userId}`, data, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
      .then((res) => {
          dispatch({ type: 'ADD_MEASUREMENT_FULFILLED', payload: {data: data.data, weighinReportDate: weighinReportDate} });
          dispatch(loadProfile(userId));
          resolve(res);
        }).catch((err) => {
          // dispatch({type: 'ADD_MEASUREMENT_REJECTEDD', payload: {error: err}})
          reject(err);
      });
    });
  }
};
